export const driveWords = {
  title: "Course folders",
  home: "Home",
  unavailableFolder: "Institutional folder unavailable here",
  openWorkspace: "Open my course folders",
  intro: "One institutional Google Drive folder for each course you teach.",
  guide: "How to use a course folder",
  guideLead:
    "Work on teaching files in Drive. Add selected files to Materials in IMAM.",
  steps: [
    [
      "Work in Drive",
      "Upload readings, create slides and organise teaching files in the course folder.",
    ],
    [
      "Choose course materials",
      "Add selected files to Materials in IMAM. Files in the folder do not appear there automatically.",
    ],
    [
      "Publish when ready",
      "Publish the material reference in IMAM when learners should see it.",
    ],
  ],
  access:
    "Use your institution's Google account. Folder setup prepares editing for verified instructors assigned to the course.",
  privacy:
    "Course folders are created for institution-wide viewing by link. Keep private learner work elsewhere.",
  audience:
    "One shared folder per course. Google controls who can open and edit its files.",
  search: "Find a course",
  searchHint: "Search course, code or term",
  term: "Courses to show",
  current: "Current and upcoming",
  past: "Past terms",
  all: "All courses",
  linked: "Folder linked",
  absent: "No folder yet",
  pending: "Folder being created",
  unknown: "Administrator help needed",
  unknownHelp:
    "The previous creation could not be confirmed. An administrator must check it before another folder is created.",
  failed: "Folder setup needs another attempt",
  open: "Open folder in Drive",
  materials: "Course materials",
  setup: "Set up folder",
  resume: "Continue folder setup",
  close: "Close setup",
  check: "Check folder status",
  refresh: "Refresh folders",
  loading: "Reading your courses and folders...",
  unavailable: "Your course folders could not be read. Try again.",
  forbidden: "This workspace is available to the assigned teaching team.",
  empty: "No courses match this view.",
  none: "No course folders to show yet.",
  retry: "Try again",
  disabled:
    "Institutional Drive folders are not enabled here yet. You can still add file links in course Materials.",
  configuration:
    "Your institution's Drive connection needs attention. Ask your administrator; course Materials still accepts file links.",
  closed:
    "The term is closed. You can open an existing folder, but a new one cannot be created.",
  stale: "These are the last folders read. A recent change may not be shown.",
  institutionSettings: "Institution integrations",
  count: (shown: number, total: number) => `${shown} of ${total} courses`,
  readAt: (at: string, stale: boolean) =>
    stale ? `As of ${at}` : `Folder links read ${at}`,
  folderName: (name: string) => `Drive folder: ${name}`,
} as const;
